<template>
  <v-content class="candidate account page">
    <v-container>
      <v-card v-if="profile">
        <v-card-title class="headline">
          Account Settings
        </v-card-title>
        <v-divider />
          <v-alert class="ma-0" :color="themes.candidate.light.primary" type="info" :value="user && user.unconfirmedEmail">
            {{ user.unconfirmedEmail }} requires verification
          </v-alert>
        <v-card-text>
          <Email :value="email" v-if="email" @done="refresh" />
        </v-card-text>
        <v-divider />
        <v-card-text v-if="!loading">
          <ReceiveDigests :value="profile.receiveDigests" />
          <CurrentlyLooking :value="profile.currentlyLooking" />
          <NationalRelocation :value="profile.willingToRelocateNationally" />
          <InternationalRelocation :value="profile.willingToRelocateInternationally" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn :color="themes.candidate.light.primaryActionButton" to="/password_reset">
            Reset password
          </v-btn>
        </v-card-actions>
      </v-card>

      <oAuth />

      <v-card v-if="profile" class="mt-5">
        <v-card-title class="headline">
          <v-icon left>mdi-heart-broken</v-icon>
          Delete Account
        </v-card-title>
        <v-divider />
        <v-card-text>
          If you no longer wish to make use of the Leaply platform you may
          <em>delete your profile and account</em>. This will <em>withdraw</em>
          all your active applications, and you will not be able to apply for
          those opportunities again. Organizations will no longer have access
          to your profile, and all uploaded documents will be permanently
          deleted. Please ensure you have copies of any documents you may
          need before proceeding.
        </v-card-text>
        <v-card-actions>
          <v-dialog :max-width="900" v-model="deleting">
            <v-btn :color="themes.candidate.light.error" slot="activator">
              Delete
            </v-btn>
            <v-card>
              <v-alert class="ma-0" :color="themes.candidate.light.error" type="error" :value="true">
                Are you sure?
              </v-alert>
              <v-card-text>
                Your profile and uploaded documents will be permanently deleted,
                and <strong>all active applications will be withdrawn</strong>.
                If you simply no longer wish to be contacted about new opportunities,
                you can update your account settings above to indicate that you are
                not currently looking for opportunities instead.
              </v-card-text>

              <v-card-actions>
                <v-btn @click="deleting = false">Cancel</v-btn><v-spacer />
                <v-btn color="error" @click="deleteProfile">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes'

// Components
import CurrentlyLooking from '@/components/candidate/profile/account/CurrentlyLooking'
import Email from '@/components/candidate/profile/account/Email'
import InternationalRelocation from '@/components/candidate/profile/account/InternationalRelocation'
import NationalRelocation from '@/components/candidate/profile/account/NationalRelocation'
import oAuth from '@/components/candidate/profile/account/oAuth'
import ReceiveDigests from '@/components/candidate/profile/account/ReceiveDigests'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  mixins: [managedDocumentAttributes],

  components: {
    CurrentlyLooking,
    Email,
    InternationalRelocation,
    NationalRelocation,
    oAuth,
    ReceiveDigests,
  },
  created() {
    this.documentAttributes.title = 'Candidate Settings - Leaply'
    this.$store.dispatch('candidate/profile/fetch').finally(() => this.loading = false)
  },
  data() {
    return {
      loading: true,
      deleting: false,
    }
  },
  computed: mapGetters({
    profile: 'candidate/profile/model',
    email: 'auth/email',
    user: 'auth/user',
  }),
  methods: {
    refresh() {
      this.loading = true
      this.$store.dispatch('auth/refresh').finally(() => this.loading = false)
    },
    deleteProfile() {
      this.$http.delete('candidate/candidate').then(() => {
        this.$store.dispatch('auth/logOut')
        this.$router.push('/')
      })
    }
  },
}
</script>
